import { StatContainer } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/MeasureProgress/components/StatContainer";
import { AltTransBusCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import { Flex } from "shared/components/Spor";

type TotalProgressionBoxProps = {
  totalCoverage: AltTransBusCoverage;
};

export const TotalProgressionBox: FC<TotalProgressionBoxProps> = ({
  totalCoverage,
}) => (
  <Flex direction="column" gap="1" minWidth="220px" maxWidth="250px">
    <StatContainer
      semantics="alarm"
      title="Behov"
      value={totalCoverage.stillRequired}
    />

    <StatContainer
      semantics="warning"
      title="Bestilt"
      value={totalCoverage.totalOrdered}
    />

    <StatContainer
      semantics="info"
      title="Bekreftet"
      value={totalCoverage.totalConfirmed}
    />

    <StatContainer
      semantics="success"
      title="Møtt opp"
      value={totalCoverage.totalOperational}
    />
  </Flex>
);
